<form [formGroup]="form" (ngSubmit)="sendLevel()">
  <div class="row">
    <div class="col-2">
      <div class="form-group validateMe">
        <label class="form-label" for="Level">{{'lang.globals.level' | translate}}</label>
        <input type="number" id="Level" class="form-control" formControlName="Level" [min]="1" [max]="100">
        <span class="form-text text-muted">{{'lang.companyLevelEdit.chooseNumber' | translate}}</span>
        <div *ngIf="Level.touched && Level.errors?.required"
             class="alert alert-danger">{{'lang.campaignLevelEdit.numberWarning' | translate}}</div>
        <div *ngIf="form.touched && form.errors?.isBetweenNumbers"
             class="alert alert-danger">{{'lang.companyLevelEdit.chooseNumber' | translate}}</div>
        <div *ngIf="form.touched && form.errors?.isLevelUnique"
             class="alert alert-danger">{{'lang.companyLevelEdit.uniqueLevel' | translate}}</div>
      </div>
    </div>
    <div class="col-5">
      <div class="form-group validateMe">
        <label class="form-label" for="Title">{{'lang.companyLevelEdit.title' | translate}}</label>
        <input type="text" id="Title" class="form-control" formControlName="Title">
        <div *ngIf="Title.touched && Title.errors?.required"
             class="alert alert-danger">{{'lang.campaignLevelEdit.titleWarning' | translate}}</div>
        <div *ngIf="form.touched && form.errors?.isTitleUnique"
             class="alert alert-danger">{{'lang.companyLevelEdit.uniqueTitle' | translate}}</div>
      </div>
    </div>
    <div class="col-5">
      <div class="form-group">
        <label class="form-label" for="Description">{{'lang.campaignLevelEdit.description' | translate}}</label>
        <input type="text" id="Description" class="form-control" formControlName="Description">
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button class="btn btn-success" [disabled]="!formValid">{{'lang.globals.submit' | translate}}</button>
  </div>
</form>
